import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import warningSVG from "images/icons/warning.svg";

export const WarningIcon = (props: IconProps) => {
  return <IconBase {...props} href={warningSVG} />;
};
